import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { DataValueMap } from 'Helpers/Testing';
import QuotedEmailText
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/EmailMessageContent/components/QuotedEmailText';
import RichTextDisplayPicker
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';

const useStyles = buildUseStyles('EmailMessageContent', ((theme) => ({
  root: {
    paddingRight: theme.spacing(2),
  },
  icon: {
    padding: theme.spacing(0, 1),
    backgroundColor: theme.palette.facet.lightGray2,
    cursor: 'pointer',
    borderRadius: '15px',
  },
  button: {
    marginBottom: theme.spacing(1),
  },
})));

const EmailMessageContent = ({
  messageResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [displayQuotedText, setDisplayQuotedText] = useState(false);
  const content = messageResource?.attr('content');

  // Separate quoted text
  const parser = new DOMParser();
  const emailDoc = parser.parseFromString(content, 'text/html');
  const quoteArray = Array.from(emailDoc.querySelectorAll('blockquote, .gmail_quote'));
  for (let i = 0; i < quoteArray.length; i++) {
    quoteArray[i].remove();
  }
  const remainingContent = emailDoc.documentElement.outerHTML;

  return (
    <Box classesName={classes.root}>
      <RichTextDisplayPicker content={remainingContent?.length ? remainingContent : ''} resource={messageResource} />
      {quoteArray.length > 0 && (
      <div
        className={classes.button}
      >
        <IconButton
          className={classes.icon}
          onClick={() => setDisplayQuotedText(!displayQuotedText)}
          size={'small'}
          icon={MoreHorizIcon}
          color={'primaryGray'}
          {...DataValueMap.init('message-email-quote-collapse-button').build()}
        />
      </div>
      )}
      <QuotedEmailText quoteArray={quoteArray} open={displayQuotedText} />
    </Box>
  );
};

EmailMessageContent.defaultProps = {
};

EmailMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
};


export default EmailMessageContent;
